(function () {
  'use strict';
 
  /*
    Cardiff Gold — Nfusion Widget Injector
    =======================================
    The Nfusion widget scripts look for their target div by ID
    on the page they load into. They MUST run on the same page
    as the div — not inside an iframe.
 
    This file is a theme Asset so Liquid/CSP cannot touch it.
    It dynamically injects both widget scripts onto the page
    after the DOM is ready, so their target divs exist first.
  */
 
  function injectScript(src) {
    var s = document.createElement('script');
    s.async = true;
    s.src = src;
    document.head.appendChild(s);
  }
 
  function init() {
    // Confirm the target divs exist before injecting
    var tickerDiv = document.getElementById('8d234c74-fc0d-4a9c-9fb1-d89d190c710a');
    var chartDiv  = document.getElementById('a66a9fb1-2eca-466b-9bff-7d298bbbf67c');
 
    if (tickerDiv) {
      injectScript(
        'https://widget.nfusionsolutions.com/widget/script/ticker/1/' +
        '5aca97b1-79e5-4062-946a-e83e28984c17/' +
        '8d234c74-fc0d-4a9c-9fb1-d89d190c710a'
      );
    }
 
    if (chartDiv) {
      injectScript(
        'https://widget.nfusionsolutions.com/widget/script/chart/1/' +
        '5aca97b1-79e5-4062-946a-e83e28984c17/' +
        'a66a9fb1-2eca-466b-9bff-7d298bbbf67c'
      );
    }
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
})();